import * as React from 'react';
import cx from 'classnames';
import { currency, date, timeStamp } from '~/lib/formatters';
import PageContentWrapper from '~/common/layout/PageContentWrapper';
import Table from '~/common/components/Table';
import {
  getPaymentName,
  getSaleStatusName,
  isSaleDeletable,
  isRemoteCheckout,
  SaleStatus,
  isSaleEditable
} from '~/apps/pos/shared/services/helpers';
import DropDownButtons from "~/common/controls/DropDownButtons";
import Button from "~/common/elements/mobile/Button";
import {buttonSize, buttonStyle} from "~/common/elements/mobile/consts";
import { getCompanyFieldLabel, getSaleNumber } from "~/apps/pos/helpers";
import TableSlicedString from "~/common/components/TableSlicedString";
import { Features } from "~/apps/shared/consts";

export default (props) => {
  const {
    orgId, onDetail, onDelete, onEdit, getOrganization, getLocation, showOrganization, showLocation,
    additionalFields, hasDepartmentFeature, hasShowCompanyFeature, features, hasAddCompletedAtFeature,
    hasHidePoNumberFeature, ...rest
  } = props;

  const handleOnDetail = (model) => {
    onDetail(model);
  };

  const handleOnDelete = (model) => {
    onDelete(model);
  };

  const handleOnEdit = (model) => {
    onEdit(model);
  }

  const getStatusClasses = (status) => {
    return cx('btn btn--sm', {
      'btn--prim': status === SaleStatus.COMPLETED.key,
      'btn--warn': status === SaleStatus.PAYMENT_FAILED.key,
      'btn--lgry': status === SaleStatus.NEW.key,
      'btn--yell': status === SaleStatus.PAYMENT_PROCESSING.key,
    });
  };

  let columnsFirst: any = [
    {
      Header: 'Date',
      id: 'date',
      accessor: d => timeStamp(d.createdAt),
    },
    {
      Header: 'Sale #',
      id: 'number',
      accessor: s => getSaleNumber(s, features),
    },
    {
      Header: 'Amount',
      id: 'price',
      accessor: c => currency(c.price),
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: s => {
        return(<span className={getStatusClasses(s.status)} style={{ 'cursor': 'default' }}>{getSaleStatusName(s.status)}</span>);
      },
      width: 140,
    },
    {
      Header: 'Payment',
      id: 'paymentType',
      accessor: p => getPaymentName(p.paymentType),
    },
  ];

  if (!hasHidePoNumberFeature) {
    columnsFirst.push({
      Header: 'PO #',
      accessor: 'poNumber',
    });
  }

  columnsFirst.push(
    {
      Header: 'Note',
      id: 'description',
      accessor: d => <TableSlicedString value={d.description} />,
    },
    {
      Header: 'Location',
      id: 'location',
      accessor: (d) => {
        const location = getLocation(d.locationId);
        return location && location.name;
      }
    },
  );

  if (hasShowCompanyFeature) {
    columnsFirst.push({
      Header: getCompanyFieldLabel(features),
      accessor: 'company',
    })
  }

  if (hasDepartmentFeature) {
    columnsFirst.push({
      Header: 'Department',
      id: 'department',
      accessor: (d) => {
        return d.department && d.department.name;
      }
    })
  }

  columnsFirst.push({
    Header: 'Shift',
    accessor: 'shift',
  })

  let columnAdditional: any = [];
  additionalFields.forEach((a) => {
      const additional = a.additionalFields;

      if (a.showInTable) {
        columnAdditional.push({
          Header: a.name,
          id: a.id,
          accessor: (d) => {
            return d.additionalFields && d.additionalFields[a.name];
          }
        })
      }
    }
  );

  if (hasAddCompletedAtFeature) {
    columnsFirst.splice(1, 0, {
      Header: 'Completed At',
      id: 'completed_at',
      accessor: d => timeStamp(d.completedAt),
    });
  }

  const dropDownOptions = (model) => {
    let options = [];

    if (model.receiptUrl
      || ((model.status === SaleStatus.PAYMENT_PROCESSING.key || model.status === SaleStatus.PAYMENT_FAILED.key)
        && isRemoteCheckout(model.paymentType))
    ) {
      options.push({
        onClick: () => handleOnDetail(model),
        title: 'Details'
      });
    }

    if (isSaleEditable(model.status, model.paymentType, model.paymentId)) {
      options.push({
        onClick: () => handleOnEdit(model),
        title: 'Edit'
      });
    }

    if (isSaleDeletable(model.status, model.paymentType)) {
      options.push({
        onClick: () => handleOnDelete(model),
        title: 'Delete'
      });
    }

    return options;
  };

  let columnsActions: any = [
    {
      Cell: (row) => {
        const model = row.original;
        const options = dropDownOptions(model);
        return <DropDownButtons options={options} />
      }
    }
  ];

  const columns = columnsFirst.concat(columnAdditional).concat(columnsActions);

  return (
    <PageContentWrapper>
      <Table
        columns={columns}
        {...rest}
      />
    </PageContentWrapper>
  );
};
